import { getEventTransfer } from 'slate-react'
import EditList from '@productboard/slate-edit-list'

const plugin = EditList({
	types: ['numbered-list', 'bulleted-list'],
	typeItem: 'list-item',
	typeDefault: 'paragraph',
})

const EditListExtended = () => {
	const onEnter = (event, editor, next) => {
		const { value } = editor
		const isSelectionInList = plugin.utils.isSelectionInList(value)

		if (!isSelectionInList) return next()

		// If selection is in list and
		// focussed block (new list item) is empty,
		// remove marks
		if (value.focusBlock.text === '') {
			if (value.marks) {
				value.marks.forEach(mark => {
					editor.removeMark(mark)
				})
			}
		}
	}

	return {
		onPaste(event, editor, next) {
			const transfer = getEventTransfer(event)
			const { text } = transfer
			const data = transfer

			const { value } = editor
			const isSelectionInList = plugin.utils.isSelectionInList(value)

			if (!isSelectionInList) return next()
			if (!data) return

			// Selection is in list and pasted content contains data
			// If pasted content is list, insert plain text,
			// otherwise, insert as it is

			if (!data.fragment && data.text) {
				editor.insertText(data.text)

				return
			}

			if (
				plugin.utils.isList(data.fragment.nodes.get(0)) &&
				value.focusBlock.text === ''
			) {
				editor.insertText(text)
			} else {
				editor.insertFragment(data.fragment)
			}
		},
		onKeyUp(event, editor, next) {
			switch (event.key) {
				case 'Enter':
					return onEnter(event, editor, next)
				default:
					return next()
			}
		},
	}
}

export default EditListExtended
